import downloadFileToResource from './downloadFileToResource';

export default downloadFileToResource;
